module.exports = __webpack_public_path__ + "static/media/Israel.ff4fdd05.png";